import { StringSanitizer } from "./StringSanitizer";

const stringSanitizer = new StringSanitizer();

export const hoofddocumentenPath = (): string => "hoofddocument";
export const hoofddocumentPath = (id: string): string => `hoofddocument/${id}`;
export const bijlagenPath = (hoofddocumentId: string): string => `hoofddocument/${hoofddocumentId}/bijlagen`;
export const bijlagePath = (hoofddocumentId: string, bijlageId: string): string =>
  `hoofddocument/${hoofddocumentId}/bijlagen/${bijlageId}`;

export const metadataPath = (id: string, hoofddocumentId?: string): string =>
  hoofddocumentId && hoofddocumentId !== id ? bijlagePath(hoofddocumentId, id) : hoofddocumentPath(id);

export const documentUrl = (documentApiEndpoint: string, id: string, hoofddocumentId?: string): string =>
  stringSanitizer.sanitizeApiEndpoint(
    documentApiEndpoint,
    "publicaties",
    metadataPath(id, hoofddocumentId),
    undefined,
    "/document"
  );
